var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"restaurants layout__content"},[_vm._l((_vm.restaurants),function(restaurant,index){return _c('div',{key:index},[_c('RestaurantForm',{attrs:{"restaurant":restaurant,"init-active":!restaurant.id,"active":_vm.isActive(restaurant.id)}})],1)}),(
      _vm.$store.getters['auth/hasAccess']({
        action: 'PUT',
        resource: '/restaurant',
      })
    )?_c('div',{staticClass:"form-card"},[_c('div',{staticClass:"form-card__body"},[_c('BButton',{attrs:{"rounded":"","outlined":"","type":"is-primary","data-test":"add-restaurant"},nativeOn:{"click":function($event){return _vm.addRestaurant()}}},[_vm._v(" "+_vm._s(_vm.$t('profile.restaurant.add'))+" ")])],1)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }